export const UPDATE_RING_MEASUREMENT_TYPE = 'UPDATE_RING_MEASUREMENT_TYPE';

export const updateRingMeasurementType = ringMeasurementType => {
    return {
        type: UPDATE_RING_MEASUREMENT_TYPE,
        payload: ringMeasurementType,
    };
};
